import React, {Component} from 'react'
import {connect} from "react-redux"
import {bindActionCreators} from "redux"
import {UserAction} from "../actions/UserAction"
import {Button, Checkbox, Divider, Input, message, Skeleton, Slider, Switch, Table} from "antd";
import {CommonAction} from "../actions/CommonAction";
import AccountService from "../services/account.service";
import {gaEventWithUserIdLabel, izBlank, izFalse, izNotEmpty, izTrue, LOG_OUT, MATCH_RATE_SLIDER_MARKS, minMatchRateFormatter} from "../constants";
import AuthService from "../services/auth.service";
import i18n from "i18next";
import {Collapse} from "reactstrap";
import Language from "./Language";
import {DeleteOutlined, MailOutlined, UserOutlined} from "@ant-design/icons";
import CompanyLicense from "./CompanyLicense";

class MatchAlertSetting extends Component {

    componentDidMount() {
        setTimeout(function () {
            this.getMatchAlertSettings();
        }.bind(this), 351);
    }

    constructor(props) {
        super(props);

        this.state = {
            matchAlertEnabled: false,
            matchAlertEnabledLoading: false,
            settingsLoading: true,
            settingsSaving: false,
            minMatchRateThreshold: 100,
            columns: [
                // {
                //     title: i18n.t('order'),
                //     dataIndex: 'order',
                //     key: 'order',
                //     render: (order, record) => order
                // },
                {
                    title: i18n.t('name'),
                    dataIndex: 'name',
                    key: 'name',
                    render: (name, record) => this.name(record)
                },
                {
                    title: i18n.t('email'),
                    dataIndex: 'email',
                    key: 'email',
                    render: (email, record) => this.email(record)
                },
                {
                    title: i18n.t('uiSearch'),
                    dataIndex: 'ui',
                    key: 'ui',
                    align: 'center',
                    width: '85px',
                    render: (ui, record) => this.uiSearch(record)
                },
                {
                    title: i18n.t('excelSearch'),
                    dataIndex: 'excel',
                    key: 'excel',
                    align: 'center',
                    width: '80px',
                    render: (excel, record) => this.excelSearch(record)
                },
                {
                    title: i18n.t('apiSearch'),
                    dataIndex: 'api',
                    key: 'api',
                    align: 'center',
                    width: '75px',
                    render: (api, record) => this.apiSearch(record)
                },
                {
                    title: i18n.t('lang'),
                    dataIndex: 'lang',
                    key: 'lang',
                    align: 'center',
                    width: '80px',
                    render: (lang, record) => this.lang(record)
                },
                {
                    title: "",
                    dataIndex: 'delete',
                    key: 'delete',
                    align: 'center',
                    width: '50px',
                    render: (lang, record) => this.deleteRecord(record)
                },
            ],
            contacts: [],
        }

    }

    handleDeleteRecord(contactOrder, e) {
        let freshContacts = [];
        for (let i = 0; i < this.state.contacts.length; i++) {
            let contact = this.state.contacts[i];
            if (contact.order !== contactOrder) {
                freshContacts.push(contact);
            }
        }

        this.setState({contacts: freshContacts});
        e.preventDefault();
    }

    deleteRecord = (record) => {

        const contactOrder = record.order;

        return (
            <a
                href="#"
                onClick={(e) => {
                    this.handleDeleteRecord(contactOrder, e)
                }}
            >{<DeleteOutlined style={{fontSize: 19}}/>}</a>
        );
    }

    handleApiChecked = (e, contactOrder) => {
        const checked = e.target.checked;

        this.updateContacts(contactOrder, checked, "API");
    }

    apiSearch = (record) => {

        const contactOrder = record.order;
        const checked = izTrue(record.api);

        return (
            <Checkbox
                name={contactOrder + "api"}
                size="large"
                checked={checked}
                onChange={(e) => {
                    this.handleApiChecked(e, contactOrder);
                }}
            />
        );
    }

    handleExcelChecked = (e, contactOrder) => {
        const checked = e.target.checked;

        this.updateContacts(contactOrder, checked, "EXCEL");
    }

    excelSearch = (record) => {

        const contactOrder = record.order;
        const checked = izTrue(record.excel);

        return (
            <Checkbox
                name={contactOrder + "excel"}
                size="large"
                checked={checked}
                onChange={(e) => {
                    this.handleExcelChecked(e, contactOrder);
                }}
            />
        );
    }

    handleUIChecked = (e, contactOrder) => {
        const checked = e.target.checked;

        this.updateContacts(contactOrder, checked, "UI");
    }

    uiSearch = (record) => {

        const contactOrder = record.order;
        const checked = izTrue(record.ui);

        return (
            <Checkbox
                name={contactOrder + "ui"}
                size="large"
                checked={checked}
                onChange={(e) => {
                    this.handleUIChecked(e, contactOrder);
                }}
            />
        );
    }

    handleEmailChange = (e, contactOrder) => {
        const value = e.target.value;

        this.updateContacts(contactOrder, value, "EMAIL");
    }

    email(record) {

        const contactOrder = record.order;

        return (
            <Input
                size="large"
                name={contactOrder + "email"}
                placeholder={i18n.t('email')}
                prefix={<MailOutlined/>}
                onChange={(e) => {
                    this.handleEmailChange(e, contactOrder);
                }}
                value={record.email}
            />
        );
    }

    handleNameChange = (e, contactOrder) => {
        const value = e.target.value;

        this.updateContacts(contactOrder, value, "NAME");
    }

    name(record) {

        const contactOrder = record.order;

        return (
            <Input
                size="large"
                name={contactOrder + "name"}
                placeholder={i18n.t('name')}
                prefix={<UserOutlined/>}
                onChange={(e) => {
                    this.handleNameChange(e, contactOrder);
                }}
                value={record.name}
            />
        );
    }

    customChangeLanguage = (lang, contactOrder) => {
        this.updateContacts(contactOrder, lang, "LANG");
    }

    lang(record) {

        const contactOrder = record.order;
        const lang = izBlank(record.lang) ? "tr" : record.lang;

        return <Language
            skipCommon={true}
            customLang={lang}
            customIndex={contactOrder}
            customChangeLanguage={this.customChangeLanguage}
            hoverDisabled={true}
        />;
    }

    updateContacts(contactOrder, value, type) {
        let freshContacts = [];
        for (let i = 0; i < this.state.contacts.length; i++) {
            let contact = this.state.contacts[i];
            if (contact.order === contactOrder) {

                if (type === "NAME") contact.name = value;
                if (type === "EMAIL") contact.email = value;
                if (type === "UI") contact.ui = izTrue(value);
                if (type === "EXCEL") contact.excel = izTrue(value);
                if (type === "API") contact.api = izTrue(value);
                if (type === "LANG") contact.lang = izBlank(value) ? "tr" : value;

                freshContacts.push(contact);
            } else {
                freshContacts.push(contact);
            }
        }

        this.setState({contacts: freshContacts});
    }

    settingsSaveListener = () => {
        this.setState({settingsSaving: true});

        setTimeout(function () {
            this.settingsSave();
        }.bind(this), 751);
    }

    settingsSave() {

        const {minMatchRateThreshold, contacts} = this.state;
        const data = {minMatchRateThreshold, contacts};

        AccountService.settingsSave(data)
            .then(
                response => {
                    this.setState({settingsSaving: false});

                    let success = response.data && response.data.success === true;
                    if (success) {
                        message.success(i18n.t('settingsSaveSuccess'));
                    } else {
                        message.error(i18n.t('global_error'));
                    }
                },
                error => {
                    this.setState({settingsSaving: false});

                    if (error.response && error.response.status === 401) {
                        AuthService.logout()
                        this.props.userAction(LOG_OUT)

                        message.error(i18n.t('login_expired'))
                    } else {
                        gaEventWithUserIdLabel("AccountService.settingsSave Error - " + i18n.t('global_error'))
                        message.error(i18n.t('global_error'))
                    }
                }
            )
    }

    getMatchAlertSettings() {
        AccountService.matchAlertSettings()
            .then(
                response => {
                    let success = response.data && response.data.success === true;
                    if (success) {
                        const {matchAlertEnabled, minMatchRateThreshold, contacts} = response.data.settings;
                        this.setState({
                            settingsLoading: false,
                            matchAlertEnabled: matchAlertEnabled,
                            minMatchRateThreshold: minMatchRateThreshold ? minMatchRateThreshold : 100,
                            contacts: izNotEmpty(contacts) ? contacts : [],
                        });
                    } else {
                        this.setState({
                            settingsLoading: false,
                            matchAlertEnabled: false
                        });
                        message.error(i18n.t('global_error'));
                    }
                },
                error => {
                    this.setState({
                        settingsLoading: false,
                        matchAlertEnabled: false
                    });

                    if (error.response && error.response.status === 401) {
                        AuthService.logout()
                        this.props.userAction(LOG_OUT)

                        message.error(i18n.t('login_expired'))
                    } else {
                        gaEventWithUserIdLabel("AccountService.matchAlertSettings Error - " + i18n.t('global_error'))
                        message.error(i18n.t('global_error'))
                    }
                }
            )
    }

    toggleMatchAlert(matchAlertEnabled) {
        AccountService.toggleMatchAlert(matchAlertEnabled)
            .then(
                response => {
                    let success = response.data && response.data.success === true;
                    if (success) {
                        this.setState({
                            matchAlertEnabledLoading: false
                        });
                        message.success(i18n.t('toggleMatchAlertSuccess'));
                    } else {
                        this.setState({
                            matchAlertEnabledLoading: false,
                            matchAlertEnabled: izFalse(matchAlertEnabled)
                        });
                        message.error(i18n.t('global_error'));
                    }
                },
                error => {
                    this.setState({
                        matchAlertEnabledLoading: false,
                        matchAlertEnabled: izFalse(matchAlertEnabled)
                    });

                    if (error.response && error.response.status === 401) {
                        AuthService.logout()
                        this.props.userAction(LOG_OUT)

                        message.error(i18n.t('login_expired'))
                    } else {
                        gaEventWithUserIdLabel("AccountService.toggleMatchAlert Error - " + i18n.t('global_error'))
                        message.error(i18n.t('global_error'))
                    }
                }
            )
    }

    toggleMatchAlertEnabled = (matchAlertEnabled) => {
        this.setState({matchAlertEnabledLoading: true, matchAlertEnabled: matchAlertEnabled});

        setTimeout(function () {
            this.toggleMatchAlert(izTrue(matchAlertEnabled));
        }.bind(this), 351);
    }

    handleMinMatchRateThreshold = (minMatchRateThreshold) => {
        this.setState({minMatchRateThreshold: minMatchRateThreshold});
    }

    handleAddNewContact = () => {
        const {contacts} = this.state;
        const contactsLength = contacts.length;

        const newContact = {
            order: contactsLength + 1,
            name: "",
            email: "",
            ui: false,
            excel: false,
            api: false,
            lang: "tr",
        };
        this.setState({
            contacts: [...contacts, newContact]
        });
    };

    render() {

        const {
            columns,
            contacts,
            matchAlertEnabled,
            matchAlertEnabledLoading,
            settingsLoading,
            settingsSaving,
            minMatchRateThreshold
        } = this.state;

        return (
            <>
                <CompanyLicense/>

                <Divider dashed className="custom-divider"/>

                <div className="p-20">
                    <Skeleton loading={settingsLoading} active>
                        <div>
                            <span className="mr-10">{i18n.t('matchAlerts')}</span>
                            <Switch
                                onChange={this.toggleMatchAlertEnabled}
                                loading={matchAlertEnabledLoading}
                                checked={matchAlertEnabled}
                                checkedChildren={i18n.t('active')}
                                unCheckedChildren={i18n.t('passive')}
                            />
                        </div>

                        <Collapse isOpen={izTrue(matchAlertEnabled)}>
                            <div className="row mt-25">
                                <div className="col-sm-12 col-md-4">
                                    <span>{i18n.t('minMatchRateThreshold')}</span>
                                </div>
                                <div className="col-sm-12 col-md-8">
                                    <Slider
                                        defaultValue={minMatchRateThreshold}
                                        tipFormatter={minMatchRateFormatter}
                                        min={60} max={100}
                                        marks={MATCH_RATE_SLIDER_MARKS}
                                        // tooltipVisible={izTrue(matchAlertEnabled)}
                                        onChange={this.handleMinMatchRateThreshold}
                                    />
                                </div>
                            </div>
                            <div className="row mt-15">
                                <div className="col-12">
                                    <Table
                                        rowKey="match-alert-contact-table"
                                        title={() => i18n.t('alertContacts')}
                                        columns={columns}
                                        dataSource={contacts}
                                        bordered
                                        className="match-alert-contact-table"
                                        pagination={{
                                            hideOnSinglePage: true,
                                            defaultPageSize: 20,
                                            total: contacts.length,
                                            showSizeChanger: false,
                                            locale: {items_per_page: ""}
                                        }}
                                    />

                                    <Button
                                        className="add-new-contact"
                                        type="primary"
                                        onClick={this.handleAddNewContact}
                                    >
                                        {i18n.t('addNewContact')}
                                    </Button>

                                    <Button
                                        className="custom-button settings-save"
                                        type="primary"
                                        onClick={this.settingsSaveListener}
                                        loading={settingsSaving}
                                    >
                                        {settingsSaving ? i18n.t('settingsSaving') : i18n.t('settingsSave')}
                                    </Button>

                                </div>
                            </div>
                        </Collapse>

                    </Skeleton>
                </div>
            </>
        )
    }

}

function mapStateToProps(state) {
    return {
        common: state.common,
        user: state.user
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        commonAction: CommonAction,
        userAction: UserAction
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(MatchAlertSetting);